import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Labelled, LabelledProps } from './Labelled';
import { Chips, ChipsChangeEvent } from 'primereact/chips';

interface LabelledInputTextProps extends LabelledProps {
  value: string[];
  onChange: (value: string[]) => void;
  pattern?: string;
  autoFocus?: boolean;
  className?: string;
  placeholder?: string;
  itemTemplate?: (item: any) => ReactNode;
}

export const LabelledChips = (props: LabelledInputTextProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  const className: string[] = [props.className, 'p-fluid'];
  return (
    <Labelled {...props}>
      <Chips
        id={props.id}
        value={props.value}
        required={props.permissions ? props.permissions?.required : false}
        invalid={!disabled && (props.validation ? !props.validation?.valid : false)}
        disabled={disabled}
        onChange={(event: ChipsChangeEvent): void => props.onChange(event.value)}
        pattern={props.pattern}
        autoFocus={props.autoFocus}
        className={className.join(' ')}
        placeholder={props.placeholder}
        itemTemplate={props.itemTemplate}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
      />
    </Labelled>
  );
};
